const STORAGE_KEY = "vpk_plate_search_history";
const MAX_HISTORY_ITEMS = 50;

function getStorage() {
  if (typeof window !== "undefined" && window.localStorage) {
    return window.localStorage;
  }
  if (typeof localStorage !== "undefined") {
    return localStorage;
  }
  return null;
}

/**
 * Hae rekisterinumeroiden hakuhistoria selaimen localStorage-muistista.
 * @returns {Array<{regNumber: string, timestamp: number, vehicleInfo: string}>}
 */
export function getPlateSearchHistory() {
  try {
    const storage = getStorage();
    if (!storage) return [];
    const raw = storage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    console.warn("Virhe luettaessa rekisterikilpien hakuhistoriaa", e);
    return [];
  }
}

/**
 * Lisää rekisterinumero hakuhistoriaan tai päivitä sen aikaleima uusimmaksi.
 * @param {string} regNumber
 * @param {string} [vehicleInfo]
 * @returns {Array} Päivitetty historia
 */
export function addPlateSearchHistory(regNumber, vehicleInfo = "") {
  if (!regNumber) return getPlateSearchHistory();
  const cleanReg = String(regNumber).trim().toUpperCase();
  if (!cleanReg) return getPlateSearchHistory();

  try {
    const storage = getStorage();
    if (!storage) return [];

    const current = getPlateSearchHistory();
    const existingIndex = current.findIndex(
      (item) => item.regNumber === cleanReg,
    );

    let resolvedVehicleInfo = vehicleInfo;
    if (existingIndex !== -1) {
      if (!resolvedVehicleInfo && current[existingIndex].vehicleInfo) {
        resolvedVehicleInfo = current[existingIndex].vehicleInfo;
      }
      current.splice(existingIndex, 1);
    }

    const newItem = {
      regNumber: cleanReg,
      timestamp: Date.now(),
      vehicleInfo: resolvedVehicleInfo || "",
    };

    const updated = [newItem, ...current].slice(0, MAX_HISTORY_ITEMS);
    storage.setItem(STORAGE_KEY, JSON.stringify(updated));
    return updated;
  } catch (e) {
    console.warn("Virhe tallennettaessa hakuhistoriaa", e);
    return [];
  }
}

/**
 * Päivitä ajoneuvon lisätiedot (merkki, malli) hakuhistorian merkintään.
 * @param {string} regNumber
 * @param {string} vehicleInfo
 */
export function updatePlateSearchVehicleInfo(regNumber, vehicleInfo) {
  if (!regNumber || !vehicleInfo) return;
  const cleanReg = String(regNumber).trim().toUpperCase();

  try {
    const storage = getStorage();
    if (!storage) return;

    const current = getPlateSearchHistory();
    const item = current.find((i) => i.regNumber === cleanReg);
    if (item) {
      item.vehicleInfo = vehicleInfo;
      storage.setItem(STORAGE_KEY, JSON.stringify(current));
    }
  } catch (e) {
    console.warn("Virhe päivitettäessä ajoneuvon tietoja historiaan", e);
  }
}

/**
 * Poista yksittäinen rekisterinumero historiasta.
 * @param {string} regNumber
 * @returns {Array} Päivitetty historia
 */
export function removePlateSearchHistoryItem(regNumber) {
  if (!regNumber) return getPlateSearchHistory();
  const cleanReg = String(regNumber).trim().toUpperCase();

  try {
    const storage = getStorage();
    if (!storage) return [];

    const current = getPlateSearchHistory();
    const filtered = current.filter((item) => item.regNumber !== cleanReg);
    storage.setItem(STORAGE_KEY, JSON.stringify(filtered));
    return filtered;
  } catch (e) {
    console.warn("Virhe poistettaessa historiaa", e);
    return [];
  }
}

/**
 * Tyhjennä koko hakuhistoria.
 */
export function clearPlateSearchHistory() {
  try {
    const storage = getStorage();
    if (!storage) return;
    storage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn("Virhe tyhjennettäessä hakuhistoriaa", e);
  }
}
